


















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';


@Component
export default class CodeInput extends Vue {
  name = 'code-input';

  @Prop(String) value: string;
  @Prop({ type: Boolean, default: true }) adjustHeightToContent: boolean;
  @Prop({ type: Boolean, default: false }) enableTabSupport: boolean;

  defaultNumberOfRows: number = 5;
  numberOfRows: number;
  domTextarea: HTMLElement;

  input = InputValidation;

  updateValue(value: string) {
    this.$emit("input", value);
  }

  @Watch("value")
  doAdjustHeightToContent() {
    if (this.adjustHeightToContent) {
      if (this.value.split("\n").length >= this.defaultNumberOfRows) {
        this.numberOfRows = this.value.split("\n").length;
      }
    }
  }

  selectionStart(): number {
    return this.domTextarea?.selectionStart;
  }

  selectionEnd(): number {
    return this.domTextarea?.selectionEnd;
  }

  getSelectedText(): string {
    if (this.selectionStart() < 0 || this.selectionEnd() < 0) {
      return "";
    }

    return this.value.substring(this.selectionStart(), this.selectionEnd());
  }

  handleKeydown(ev) {
    const TAB = 9;
    const INSERT = 45;

    if (this.enableTabSupport && ev.keyCode == TAB) {
      this.insertTextAtCursor("\t");
      ev.preventDefault();
    }
    if (ev.keyCode == INSERT) {
      alert(this.getSelectedText());
    }
  }

  insertTextAtCursor(str: string) {
    let textarea = this.$refs?.textarea?.$el?.querySelector("textarea");
    if (textarea) {
      const pos = textarea.selectionStart;
      if (pos >= 0) {
        this.value = this.value.substring(0, pos) + str + this.value.substring(pos);
      }
    }
  }

  created() {
    this.numberOfRows = this.defaultNumberOfRows;
  }

  mounted() {
    this.domTextarea = this.$refs?.textarea?.$el?.querySelector("textarea");
  }

}
